module.exports = __webpack_public_path__ + "img/Logo-sq.9a8a331.png";